import AssessmentPaper from '@/apps/assessment/components/assessment-paper'
import BasicLayout from '@/apps/assessment/components/basic-layout/index.vue'
import AssessmentTrackMixin from '@/apps/assessment/mixins/assessment-track-mixin'
import RouterMixin from '@/apps/assessment/mixins/clazz-router-mixin'
import { myPaperList } from '@/apps/assessment/model/api'
import PaperPending from '@/apps/paper/components/paper-pending'
import { Ranger } from '@/components'
import SmallBtnSkeleton from '@/components/common/small-btn-skeleton'
import { Component, Mixins, Prop, Provide, Vue, Watch } from 'vue-property-decorator'

const proSource = '我的试卷'
@Component({ components: { AssessmentPaper, BasicLayout, Ranger, PaperPending, SmallBtnSkeleton } })
export default class ClazzAssessmentPapers extends Mixins(RouterMixin, AssessmentTrackMixin) {
  private paperList = []
  private page = 1
  private sum = 0
  private perPage = 10
  private loading = true
  // 新增字段
  private keyword = ''
  private usenumStatus = 'down'
  private usenumSelected = false
  private updateStatus = 'down'
  private updateSelected = true

  private get subject() {
    return this.$store.state.subject
  }
  // 展示状态
  public get switchTemplate() {
    if (this.loading) {
      return 'pending'
    } else {
      if (this.paperList && this.paperList.length > 0) {
        return 1
      } else {
        return 2
      }
    }
  }

  @Watch('subject', { deep: true })
  public onSubjectChange(val) {
    this.keyword = ''
    this.myPaperList()
  }

  public mounted() {
    this.myPaperList()
  }
  public onPageChange(page: number): void {
    this.page = page
    this.myPaperList()
  }

  public async myPaperList() {
    try {
      let sort_way = '-updated_at'
      if (this.updateSelected) {
        if (this.updateStatus === 'up') {
          sort_way = 'updated_at'
        } else {
          sort_way = '-updated_at'
        }
      }
      if (this.usenumSelected) {
        if (this.usenumStatus === 'up') {
          sort_way = 'exam_use_num'
        } else {
          sort_way = '-exam_use_num'
        }
      }
      this.loading = true
      const data: any = await myPaperList({
        subject_id: Number(this.subject.value),
        page: this.page,
        keyword: this.keyword && this.keyword,
        sort_way
      })
      if (data.success) {
        this.paperList = data.data.records
        this.sum = data.data.total
      } else {
        this.sum = 0
        this.paperList = []
      }
    } catch (e) {
      console.log(e)
    } finally {
      this.loading = false
    }
  }

  public publish(data) {
    this.trackPublish('去发布', proSource)
    this.$router.push({
      path: '/clazz/publish',
      query: {
        subject: this.subject.nick,
        subject_id: this.subject.value,
        pid: data.paper.old_paper_id,
        s: 'PERSONAL_ASSESSMENT',
        f: encodeURIComponent(proSource)
      }
    })
  }
  public preview(data) {
    this.trackPublish('试卷预览', proSource)
    this.$router.push({
      path: '/clazz/paper',
      query: {
        _id: data.id,
        subject: this.subject.nick,
        subject_id: this.subject.value,
        s: 'PERSONAL_ASSESSMENT',
        paper: encodeURIComponent(JSON.stringify(data))
      }
    })
  }
  // 清空输入内容时自动检索
  public onKeywordChange() {
    if (this.keyword === '') {
      this.page = 1
      this.myPaperList()
    }
  }
  // 点击搜索
  public onSearch() {
    this.page = 1
    this.myPaperList()
  }
  // sorter ranger
  public onUsenumChange(val) {
    this.usenumStatus = val
    this.page = 1
    this.myPaperList()
  }
  public onSelectUsenum() {
    this.usenumSelected = true
    this.updateSelected = false
    this.page = 1
    this.myPaperList()
  }
  public onUpdateChange(val) {
    this.updateStatus = val
    this.page = 1
    this.myPaperList()
  }
  public onSelectUpdate() {
    this.updateSelected = true
    this.usenumSelected = false
    this.page = 1
    this.myPaperList()
  }
}
